<template>
  <BCard>
    <div class="font-bold m-0 text-black text-2xl">
      Riwayat Pengajuan
    </div>
    <div class="flex items-center flex-wrap gap-[10px] mt-[20px] mb-[10px]">
      <b-button
        pill
        :variant="isPengajuanPartner ? 'primary' : 'light'"
        size="sm"
        class="rounded-lg !py-[12px] !px-[24px] !flex items-center gap-2"
        @click="handleChangeTab('partner')"
      >
        Pengajuan Partner
      </b-button>
      <b-button
        pill
        :variant="isPengajuanMitra ? 'primary' : 'light'"
        size="sm"
        class="rounded-lg !py-[12px] !px-[24px] !flex items-center gap-2"
        @click="handleChangeTab('mitra')"
      >
        Pengajuan Mitra
      </b-button>
    </div>
    <PengajuanPartner v-if="isPengajuanPartner" />
    <PengajuanMitra v-if="isPengajuanMitra" />
  </BCard>
</template>

<script>
import PengajuanPartner from './components/PengajuanPartner.vue'
import PengajuanMitra from './components/PengajuanMitra.vue'

export default {
  components: {
    PengajuanPartner,
    PengajuanMitra,
  },
  data() {
    return {
      activeTab: this.$route.query.tab || 'partner',

    }
  },
  computed: {
    isPengajuanPartner() {
      return this.activeTab === 'partner'
    },
    isPengajuanMitra() {
      return this.activeTab === 'mitra'
    },
  },
  methods: {
    /**
     * @description Handle change tab.
     * @param tab {string} - Tab to change to
     */
    handleChangeTab(tab) {
      this.activeTab = tab
      this.$router.push({ query: { tab } })
    },
  },
}
</script>
